<template>
  <v-container >


<p id="SCREEN" ></p>
        <SCREEN  />


<p id="DUO" ></p>
        <DUO  />

<p id="BLACKOUT" ></p>
        <BLACKOUT  />

<p id="LUXURY" ></p>
   <lUXURY />
<p id="VERTICALES" ></p>
   <VERTICALES />
 <p id="TRADICIONAL" ></p>

<TRADICIONAL/>



<p id="Ambiente" ></p>
        <ANA  />



  </v-container>
</template>

<script>
import DUO from "@/views/Servicios/DUO.vue";
import BLACKOUT from "@/views/Servicios/BLACKOUT.vue";
import ADONS from "@/views/Servicios/ADONS.vue";
import SCREEN from "@/views/Servicios/SCREEN.vue";
import LUXURY from "@/views/Servicios/LUXURY.vue";
import VERTICALES from "@/views/Servicios/VERTICALES.vue";
import SAPS4HANA4 from "@/views/Servicios/SAPS4HANA4.vue";
import ANA from "@/views/Servicios/ANA.vue";
import TRADICIONAL from "@/views/Servicios/TRADICIONAL.vue";
import db from "@/firebase/init.js";
import firebase from "firebase";
export default {
  name: "Ecommerce",
  components: {ANA,TRADICIONAL,DUO,BLACKOUT,ADONS,LUXURY,VERTICALES,SAPS4HANA4,SCREEN},
  props: [],

  data() {
    return {
      productos: "",
      areas: "",
      funcion: "",
      foto2: "",
      descripcion: "",
      titulo: "",
      mensaje: "",
      desserts: [
        { item: "Cantidad de productos", name: 50, calories: 50, p: 50, a: 50 },

        { item: "Cantidad de Fotos* ", name: 5, calories: 5, p: 5, a: 5 },
        { item: "Cantidad de Videos*", name: 2, calories: 2, p: 2, a: 2 },
        {
          item: "Visualización Multidispositivo",
          name: "si",
          calories: "si",
          p: "si",
          a: "si",
        },
        {
          item: "Conexión segura SSL y HTTPS",
          name: "si",
          calories: "si",
          p: "si",
          a: "si",
        },

        {
          item: "Carro de compras e Integración de medios de pago",
          name: "",
          calories: "si",
          p: "si",
          a: "si",
        },

        {
          item: "Comunidad de clientes Condominios",
          name: "",
          calories: "",
          p: "si",
          a: " Gratis MarketPlace Shopery ",
        },

        {
          item: "Sistema de Fideliazación QR",
          name: "",
          calories: "",
          p: "",
          a: " si",
        },
        {
          item: "Sistema de Agendamiento",
          name: "",
          calories: "",
          p: "",
          a: " si",
        },
        {
          item: "Mensajes de notificación ",
          calories: "",
          p: "",
          a: " si",
        },
        {
          item: "Sistema de promocion de Ventas ",
          calories: "",
          p: "",
          a: " si",
        },

        { item: "* por cada producto", name: "", calories: "", p: "", a: "" },
      ],
    };
  },
  created() {
    var docRef = db.collection("web").doc("Servicios Sap");
    docRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          this.productos = doc.data().AF1;
          this.foto2 = doc.data().AF0;
          this.titulo = doc.data().BN1;
          this.mensaje = doc.data().CM0;
          this.descripcion = doc.data().DD1;
          this.funcion = doc.data().EF0;
          this.funciones = doc.data().EF1;
          this.areas = doc.data().FB1;
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });
  },
  methods: {
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },

    methods: {
      web() {
        this.$router.push({ path: "web" });
        this.dialog = false;
      },

      ecommerce() {
        this.$router.push({ path: "/ecommerce" });
        this.dialog = false;
      },

      market() {
        this.$router.push({ path: "/market" });
        this.dialog = false;
      },
      apps() {
        this.$router.push({ path: "/apps" });
        this.dialog = false;
      },
      foto() {
        this.$router.push({ path: "/foto" });
        this.dialog = false;
      },
      gestion() {
        this.$router.push({ path: "/social" });
        this.dialog = false;
      },
      inicio() {
        this.$router.push({ path: "/" });
        this.dialog = false;
      },
    },
  },

  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "230px";
        case "sm":
          return "290px";
        case "md":
          return "363px";
        case "lg":
          return "435px";
        case "xl":
          return "600px";
      }
    },

    imageWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "290px";
        case "sm":
          return "320px";
        case "md":
          return "4200px";
        case "lg":
          return "610px";
        case "xl":
          return "650px";
      }
    },
  },
};
</script>
